import RawOutput from './RawOutput';
import ScssLine  from './Line/ScssLine';

export default class ScssOutput extends RawOutput {

    static line = ScssLine;
}